import { render, staticRenderFns } from "./popularProducts.vue?vue&type=template&id=562d0706&"
import script from "./popularProducts.vue?vue&type=script&lang=js&"
export * from "./popularProducts.vue?vue&type=script&lang=js&"
import style0 from "./popularProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports